import * as React from "react";

function SvgFreeTimeSleeping(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 572 581"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <g transform="translate(-131.031 -88.28)">
        <g id="free_time_sleeping_svg__sleeping">
          <text
            x={103.026}
            y={395.181}
            fontFamily="'RubikMonoOne-Regular','Rubik Mono One'"
            fontSize={150}
            fill="#fe8f8c"
            transform="translate(16.305 273.099)"
          >
            {"z"}
          </text>
          <text
            x={103.026}
            y={395.181}
            fontFamily="'RubikMonoOne-Regular','Rubik Mono One'"
            fontSize={250}
            fill="#fea09d"
            transform="translate(140.555 148.099)"
          >
            {"z"}
          </text>
          <text
            x={103.026}
            y={395.181}
            fontFamily="'RubikMonoOne-Regular','Rubik Mono One'"
            fontSize={350}
            fill="#feb4b2"
            transform="translate(328.305 -61.901)"
          >
            {"z"}
          </text>
        </g>
      </g>
    </svg>
  );
}

export default SvgFreeTimeSleeping;
